import checkCredentials from '../authentication/checkCredentials';
var AWS = require('aws-sdk');

AWS.config.update({
  region: 'us-east-1',
});

const DivisionToValue = { FBS: 0, FCS: 1, 'Division II': 2, 'Division III': 3 };
const ConferenceToDivision = {
  ACC: 'FBS',
  American: 'FBS',
  'Big 12': 'FBS',
  'Big Ten': 'FBS',
  'C-USA': 'FBS',
  Independent: 'FBS',
  MAC: 'FBS',
  'Mountain West': 'FBS',
  'Pac-12': 'FBS',
  SEC: 'FBS',
  'Sun Belt': 'FBS',
  'Big Sky': 'FCS',
  'Big South': 'FCS',
  CAA: 'FCS',
  Ivy: 'FCS',
  MEAC: 'FCS',
  'Missouri Valley': 'FCS',
  Northeast: 'FCS',
  'Ohio Valley': 'FCS',
  Patriot: 'FCS',
  Pioneer: 'FCS',
  Southern: 'FCS',
  Southland: 'FCS',
  SWAC: 'FCS',
  CIAA: 'Division II',
  GAC: 'Division II',
  GLIAC: 'Division II',
  GLVC: 'Division II',
  GNAC: 'Division II',
  'Gulf South': 'Division II',
  LSC: 'Division II',
  MEC: 'Division II',
  MIAA: 'Division II',
  'NE-10': 'Division II',
  NSIC: 'Division II',
  PSAC: 'Division II',
  RMAC: 'Division II',
  SAC: 'Division II',
  SIAC: 'Division II',
  ASC: 'Division III',
  CCIW: 'Division III',
  Centennial: 'Division III',
  ECFC: 'Division III',
  'Empire 8': 'Division III',
  HCAC: 'Division III',
  IIAC: 'Division III',
  Liberty: 'Division III',
  'MAC (D3)': 'Division III',
  MASCAC: 'Division III',
  MIAC: 'Division III',
  MWC: 'Division III',
  NACC: 'Division III',
  NCAC: 'Division III',
  NEFC: 'Division III',
  NESCAC: 'Division III',
  NJAC: 'Division III',
  NWC: 'Division III',
  OAC: 'Division III',
  ODAC: 'Division III',
  PAC: 'Division III',
  SAA: 'Division III',
  SCAC: 'Division III',
  SCIAC: 'Division III',
  UMAC: 'Division III',
  'USA South': 'Division III',
  WIAC: 'Division III',
};

function sortConferences(a, b) {
  const aDivision = ConferenceToDivision[a];
  const bDivision = ConferenceToDivision[b];
  const aVal = DivisionToValue[aDivision];
  const bVal = DivisionToValue[bDivision];

  if (aVal < bVal) {
    return -1;
  } else if (aVal > bVal) {
    return 1;
  } else if (a < b) {
    return -1;
  } else if (a > b) {
    return 1;
  }

  return 0;
}

function loadConferenceFile() {
  return new Promise((resolve, reject) => {
    checkCredentials()
      .then((cognitoUser) => {
        const params = {
          Bucket: 'zcruitfiles',
          Key: 'conference.json',
        };

        const s3 = new AWS.S3();

        return s3.getObject(params).promise();
      })
      .then((res) => {
        const conferenceJSON = JSON.parse(res.Body.toString());
        const final = [];

        Object.keys(conferenceJSON)
          .sort((a, b) => {
            const result = sortConferences(a, b);

            return result;
          })
          .forEach((conf) => {
            const children = [];
            const schoolList = conferenceJSON[conf];

            schoolList.forEach((school) => {
              const obj = {
                value: school,
                label: school,
              };

              children.push(obj);
            });

            const confObj = {
              value: conf,
              label: conf,
              children: children,
            };

            final.push(confObj);
          });

        return resolve(final);
      })
      .catch((err) => {
        console.log(err);
      });
  });
}

export default loadConferenceFile;



// WEBPACK FOOTER //
// ./src/constants/getConferenceFile.js